import "jquery/dist/jquery";
import '@popperjs/core/dist/esm/popper';
import "bootstrap/dist/js/bootstrap.bundle";

import "bootstrap-icons/font/bootstrap-icons.min.css";

import "~/shared/prefilter";

import "~/scss/main.scss";

require("~/assets/images/dataset_placeholder_logo.png");
require("~/assets/images/dataset_placeholder_logo_light.png");
